const initialState = {
  transactions: [],
  lastDoc: null,
  hasMore: true,
  metrics: {
    totalRevenue: 0,
    totalTransactions: 0,
    activeBoosts: 0,
    averageTransaction: 0,
  },
  selectedTransaction: null,
  loading: false,
  loadingMore: false,
  metricsLoading: false,
  detailLoading: false,
  error: null,
};

const adminBoostReducer = (state = initialState, action) => {
  switch (action.type) {
    case "BOOST_TRANSACTIONS_LOADING":
      return { ...state, loading: true, error: null };

    case "SET_BOOST_TRANSACTIONS":
      return {
        ...state,
        loading: false,
        transactions: action.payload.transactions,
        lastDoc: action.payload.lastDoc,
        hasMore: action.payload.hasMore,
      };

    case "BOOST_LOAD_MORE_LOADING":
      return { ...state, loadingMore: true };

    case "APPEND_BOOST_TRANSACTIONS":
      return {
        ...state,
        loadingMore: false,
        transactions: [...state.transactions, ...action.payload.transactions],
        lastDoc: action.payload.lastDoc,
        hasMore: action.payload.hasMore,
      };

    case "BOOST_TRANSACTIONS_ERROR":
      return { ...state, loading: false, loadingMore: false, error: action.payload };

    case "BOOST_METRICS_LOADING":
      return { ...state, metricsLoading: true };

    case "SET_BOOST_METRICS":
      return { ...state, metricsLoading: false, metrics: action.payload };

    case "BOOST_METRICS_ERROR":
      return { ...state, metricsLoading: false, error: action.payload };

    case "BOOST_DETAIL_LOADING":
      return { ...state, detailLoading: true };

    case "SET_BOOST_SELECTED_TRANSACTION":
      return { ...state, detailLoading: false, selectedTransaction: action.payload };

    case "BOOST_DETAIL_ERROR":
      return { ...state, detailLoading: false, error: action.payload };

    case "CLEAR_BOOST_SELECTED_TRANSACTION":
      return { ...state, selectedTransaction: null };

    default:
      return state;
  }
};

export default adminBoostReducer;
